import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import Home from "./pages/Home";
import Order from "./pages/Order";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
console.log("This is for the record.")
console.log("History is written by the Victor")
function App() {
  return (
    <MantineProvider
      theme={{
        colors: {
          brand: [
            "#fff5f5",
            "#fed7d7",
            "#feb2b2",
            "#fc8181",
            "#f56565",
            "#e53e3e",
            "#c53030",
            "#9b2c2c",
            "#742a2a",
            "#742a2a",
          ],
        },
        primaryColor: "brand",
        fontFamily: "Inter, sans-serif",
        components: {
          Button: {
            defaultProps: {
              radius: "md",
            },
          },
          Input: {
            defaultProps: {
              radius: "md",
            },
          },
          Select: {
            defaultProps: {
              radius: "md",
            },
          },
        },
      }}
    >
      <DatesProvider settings={{ locale: "en" }}>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/order" element={<Order />} />
          </Routes>
        </Router>
      </DatesProvider>
    </MantineProvider>
  );
}

export default App;
